export default __webpack_public_path__ + "static/media/wal.83947109.svg";